import { Schema as S } from "effect";
import { defineMessageUnion } from "foldkit/message";

import { getEvents } from "../../api/commands/events";

export const Message = defineMessageUnion({
	ChangedSearch: { search: S.String },
	ClickedLoadMore: {},
	CompletedFetchEvents: {
		search: S.String,
		cursor: S.Number,
		asOf: S.Option(S.String),
		generation: S.Number,
		result: getEvents.Result,
	},
});
export type Message = typeof Message.Type;
